import NotificationService from "../components/Notification/notificationService";
import { Shirt } from "../entities/Shirt";
import { buildParams, buildParamsDataOld, ParamsData } from "./api/api";
import LoginService from "./loginService";
import { PublicShirt, ShirtInterface } from "./shirts/types";
import { getLastShirts } from "./api/publicDataService";

export default function PublicDataService() {
  const { error: errorNotification } = NotificationService();
  const { setLogout } = LoginService();

  const handleError = (status: number, description: string) => {
    if (status === 401) {
      setLogout();
    } else {
      errorNotification(description);
    }
  };

  const lastShirts = async (count: number) => {
    let response = await getLastShirts(count).catch(function (error) {
      const status = error.response.status;
      const description = error.response.data.error_description;
      handleError(status, description);
    });
    if (response?.data) {
      const result: Array<PublicShirt> = response.data;

      return result;
    } else {
      return undefined;
    }
  };

  return {
    lastShirts,
  };
}
